import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
    const [user, setUser] = useState(null);
    const [searchQuery, setSearchQuery] = useState(''); 
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        } else {
            setUser(null);
        }
        setIsMenuOpen(false);
    }, [location]);

    const handleLogout = () => {
        localStorage.removeItem('user');
        setUser(null);
        navigate('/login');
    };

    const handleSearch = (e) => {
        if (e.key === 'Enter' && searchQuery.trim() !== '') {
           navigate(`/search?query=${searchQuery}`);
        }
    };

    return (
        <header className="site-header" style={{ backgroundColor: '#134628', borderBottom: '4px solid #ffc300' }}>
            <style>{`
                .site-header {
                    background-color: #134628 !important; /* Updated to Sherian Green */
                    color: #ffffff;
                    padding: 0 20px;
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: 80px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 1000;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                    border-bottom: 4px solid #ffc300;
                    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                }

                .header-container {
                    width: 100%;
                    max-width: 1400px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }

                /* 🌟 UPDATED LOGO CONTAINER STYLES */
                .header-logo {
                    text-decoration: none;
                    display: flex;
                    align-items: center; 
                    gap: 15px; 
                }

                .logo-img {
                    height: 55px; 
                    width: auto;
                    border-radius: 50%; 
                    border: 2px solid #ffc300; 
                    background: #fff;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
                }

                .logo-text-wrapper {
                    display: flex;
                    flex-direction: column;
                }

                .logo-text-wrapper h1 {
                    color: #ffc300;
                    margin: 0;
                    font-size: 1.8rem;
                    font-weight: 900;
                    letter-spacing: 2px;
                    line-height: 1;
                }

                .logo-text-wrapper span {
                    color: #ffffff;
                    font-size: 0.75rem;
                    letter-spacing: 1px;
                    text-transform: uppercase;
                    opacity: 0.9;
                }

                .header-search {
                    position: relative;
                    width: 300px;
                    margin: 0 20px;
                }

                .header-search input {
                    width: 100%;
                    padding: 10px 15px 10px 40px;
                    border-radius: 50px;
                    border: 1px solid rgba(255,255,255,0.2);
                    background: rgba(255,255,255,0.1);
                    color: white;
                    font-size: 0.9rem;
                    outline: none;
                    transition: all 0.3s ease;
                }

                .header-search input::placeholder {
                    color: rgba(255,255,255,0.6);
                }

                .header-search input:focus {
                    background: rgba(255,255,255,0.15);
                    border-color: #ffc300;
                }

                .header-search i {
                    position: absolute;
                    left: 15px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #a0c4ff;
                }

                .header-nav {
                    display: flex;
                    align-items: center;
                    gap: 25px;
                }

                .nav-link {
                    color: #ffffff;
                    text-decoration: none;
                    font-weight: 700;
                    font-size: 0.9rem;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    transition: color 0.3s ease;
                }

                .nav-link:hover {
                    color: #ffc300;
                }

                .btn-dashboard {
                    background: transparent;
                    color: #ffc300;
                    border: 2px solid #ffc300;
                    padding: 8px 20px;
                    border-radius: 50px;
                    text-decoration: none;
                    font-weight: 800;
                    font-size: 0.9rem;
                    text-transform: uppercase;
                    transition: all 0.3s ease;
                }

                .btn-dashboard:hover {
                    background: #ffc300;
                    color: #134628; /* Updated to Sherian Green for text contrast */
                    box-shadow: 0 4px 15px rgba(255, 195, 0, 0.3);
                }

                .btn-join {
                    background: transparent;
                    color: #ffffff;
                    border: 1px solid rgba(255,255,255,0.5);
                    padding: 8px 20px;
                    border-radius: 50px;
                    text-decoration: none;
                    font-weight: 700;
                    font-size: 0.9rem;
                    text-transform: uppercase;
                    transition: all 0.3s ease;
                }

                .btn-join:hover {
                    border-color: #ffc300;
                    color: #ffc300;
                }

                .btn-logout-header {
                    background: transparent;
                    color: #d90429;
                    border: 1px solid #d90429;
                    padding: 8px 20px;
                    border-radius: 50px;
                    font-weight: 700;
                    font-size: 0.9rem;
                    text-transform: uppercase;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }

                .btn-logout-header:hover {
                    background: #d90429;
                    color: #ffffff;
                    box-shadow: 0 4px 15px rgba(217, 4, 41, 0.3);
                }

                .menu-toggle {
                    display: none;
                    background: transparent;
                    border: none;
                    color: #ffc300;
                    font-size: 1.8rem;
                    cursor: pointer;
                    z-index: 1100;
                }

                @media (max-width: 992px) {
                    .header-search { display: none; }
                    .header-nav { gap: 15px; }
                }
                
                @media (max-width: 768px) {
                    .menu-toggle { display: block; }
                    
                    .logo-text-wrapper h1 { font-size: 1.4rem; }
                    .logo-img { height: 45px; }

                    .header-nav {
                        position: fixed;
                        top: 80px;
                        left: 0;
                        right: 0;
                        background-color: #134628; /* Updated to Sherian Green */
                        flex-direction: column;
                        padding: 30px 20px;
                        gap: 25px;
                        border-bottom: 4px solid #ffc300;
                        transform: translateY(-150%);
                        transition: transform 0.4s ease-in-out;
                        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
                    }

                    .header-nav.active {
                        transform: translateY(0);
                    }

                    .btn-dashboard, .btn-join, .btn-logout-header {
                        width: 100%;
                        text-align: center;
                    }
                }
            `}</style>

            <div className="header-container">
                <Link to="/" className="header-logo">
                    <img src="/logo.jpeg" alt="Sherian Logo" className="logo-img" />
                    <div className="logo-text-wrapper">
                        <h1>SHERIAN</h1>
                        <span>Alumni Association</span>
                    </div>
                </Link>

                {/* <div className="header-search">
                    <i className="fas fa-search"></i>
                    <input 
                        type="text" 
                        placeholder="Search Kit No..." 
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onKeyDown={handleSearch}
                    />
                </div> */}

                <button className="menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                    <i className={isMenuOpen ? "fas fa-times" : "fas fa-bars"}></i>
                </button>

                <nav className={`header-nav ${isMenuOpen ? 'active' : ''}`}>
                    <Link to="/" className="nav-link">Home</Link>
                    <Link to="/about" className="nav-link">About College</Link>
                    
                    {user ? (
                        <>
                            <Link to="/dashboard" className="btn-dashboard">
                                <i className="fas fa-user-circle me-2"></i> My Dashboard
                            </Link>
                            <button onClick={handleLogout} className="btn-logout-header">
                                Logout
                            </button>
                        </>
                    ) : (
                        <>
                        <Link to="/elections" className="nav-link">Decision Portal</Link>
                            <Link to="/login" className="nav-link">Login</Link>
                            <Link to="/register" className="btn-join">Join Alumni</Link>
                        </>
                    )}
                </nav>
            </div>
        </header>
    );
};

export default Header;